import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";

const API_KEY = "d0d0e4b5f11eccb0cab298bbb66068273ab5a3d145a993577cc9a94a761273f6";

export default function Products() {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get("https://xalavach.ru/api/products.php", {
        headers: { Authorization: `Bearer ${API_KEY}` },
      })
      .then((res) => {
        const groupedProducts = res.data.reduce((acc, product) => {
          if (!acc[product.name]) {
            acc[product.name] = {
              ...product,
              count: 1,
              image_url: `https://xalavach.ru/api/image.php?file=${product.avatar_image}`,
            };
          } else {
            acc[product.name].count++;
          }
          return acc;
        }, {});

        setProducts(Object.values(groupedProducts));
      })
      .catch((err) => console.error("Ошибка загрузки продуктов:", err));
  }, []);

  return (
    <div className="pt-24 px-4 pb-10 min-h-screen bg-gradient-to-b from-[#1A1A2E] to-[#16213E] text-white">
      {/* Заголовок */}
      <div className="flex justify-center">
        <h2 className="text-lg sm:text-xl font-bold text-center px-4 py-2 rounded-md bg-[#222A3A] bg-opacity-80 text-blue-400 shadow-md">
          ✨ Популярные предложения
        </h2>
      </div>

      {/* Контейнер карточек (всегда влазят в экран) */}
      <div className="mt-6 flex flex-wrap justify-center gap-5">
        {products.map((product, index) => (
          <motion.div
            key={product.id}
            className="w-[44%] sm:w-[30%] md:w-[22%] lg:w-[18%] bg-gradient-to-br from-[#232A3B] to-[#1E2A47] 
                       p-5 rounded-xl shadow-lg flex flex-col items-center cursor-pointer 
                       transform transition-all hover:scale-105 hover:shadow-xl border border-gray-700"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1, duration: 0.4 }}
            onClick={() => navigate(`/product/${product.id}`)}
          >
            <img
              src={product.image_url}
              alt={product.name}
              className="w-20 h-20 sm:w-24 sm:h-24 rounded-full shadow-md mb-3 object-cover border-2 border-white"
            />
            <h3 className="text-md sm:text-lg font-semibold text-center">{product.name}</h3>
            <p className="text-sm sm:text-md text-gray-400">{product.count} {getOfferText(product.count)}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
}

// Функция склонения слова "предложение"
function getOfferText(count) {
  if (count % 10 === 1 && count % 100 !== 11) return "предложение";
  if (count % 10 >= 2 && count % 10 <= 4 && (count % 100 < 10 || count % 100 >= 20)) return "предложения";
  return "предложений";
}
